export const ACTIVATE_WORKSPACE_WORKFLOW_SKILL_NAME =
  "activate_workspace_workflow_skill";

export const ACTIVATE_WORKSPACE_WORKFLOW_SKILL_DESC = `Attaches an ACTIVE workspace skill to the current chat thread.

Inputs:
- workflowSkillId (optional): Concrete skill ID to sign and activate. Use the workflowSkillId listed in the "Available skills" section. Never pass a skill title here; a title is not an ID and the approval will fail.
- skillTitle (optional): Discovery-only title. If you do not know the ID, call with skillTitle ONLY (omit workflowSkillId) to receive candidate IDs, then retry with the returned workflowSkillId.

Use this when the user wants to activate an approved skill for the current thread. Activation runs through confirmation.`;
